import {EData} from "@/Fwk/Kit/Track/EData";
import { IStore } from "./IStore";
import { KitSp } from "../KitSp";
import KitLog from "../KitLog";
import { KitTrack } from "./KitTrack";
import {CacheManager} from "@/Fwk/Kit/Track/CacheManager";

export class SpStore implements IStore
    {
        private static CACHE_KEY_PER = "event";

        private static BuildKey(data: EData): string {
            const key = `${this.CACHE_KEY_PER}_${data.BuildIndexName()}`;
            return key;
        }

        public Read(data: EData)
        {
            const sData = SpStore.ReadTextFromSp(SpStore.BuildKey(data));
            data.SetText(sData);
        }

        // 从文件中读取文本
        private static ReadTextFromSp(key: string): string {
            return KitSp.GetString(key);
        }

        public Write(data:EData )
        {
            var key = SpStore.BuildKey(data);
            var text = data.GetText();
            if (KitLog.IsLog)
            {
                KitTrack.Log(`保存Sp-key：${key}`);
                KitTrack.Log(`保存Sp-Text：${text}`);
            }

            SpStore.SaveTextToSp(key, text);
        }


        // 保存文本
        private static SaveTextToSp(key: string, content: string)
        {
            try
            {
                // Sp保存
                KitSp.SetString(key, content);
                KitSp.Apply();
            }
            catch (e)
            {
                if (KitLog.IsLog) KitTrack.Log(`保存缓存Sp失败-key：${key}，错误:${e}`);
            }
        }

        public  LoadAll():EData[]
        {
            const list: EData[] = [];
            const kVs = KitSp.ReadAllStringKVs();
            if (kVs.size <= 0) return list;

            kVs.forEach((item,key)=>{
                if (!key) return;
                const values = item;
                if (!key.startsWith(`${SpStore.CACHE_KEY_PER}_`)) return;
                const name = key.replace(`${SpStore.CACHE_KEY_PER}_`, "");
                const indexName = parseInt(name);
                if (!isNaN(indexName)) {
                    let type = KitTrack.SRC_TYPE_DELAY;
                    if (indexName > KitTrack.SRC_TYPE_DELAY * CacheManager.FILE_K)
                        type = KitTrack.SRC_TYPE_DELAY;
                    else if (indexName > KitTrack.SRC_TYPE_COM * CacheManager.FILE_K)
                        type = KitTrack.SRC_TYPE_COM;
                    else if (indexName > KitTrack.SRC_TYPE_NOW * CacheManager.FILE_K)
                        type = KitTrack.SRC_TYPE_NOW;
                    const id = indexName % CacheManager.FILE_K;
                    const data = new EData(id, type, values);
                    list.push(data);
                } else {
                    if (KitLog.IsLog) KitLog.Log(`删除错误缓存Sp：${key}1`);
                    SpStore.DeleteSp(key);
                }
            })

            return list;
        }

        public Remove(eData: EData) {
            SpStore.DeleteSp(SpStore.BuildKey(eData));
        }

        // 删除文件
        private static DeleteSp(key: string) {
            try {
                KitSp.Remove(key);
                KitSp.Apply();
            } catch (e) {
                if (KitLog.IsLog) KitLog.Log(`删除缓存Sp错误，错误:${e}`);
            }
        }
    }
